export function showPopUp() {
    const $body = $("body");
    let $globalParent;
    let $iframeScr;
    let $src;
    $(document).on("click", ".open-pop-up", function (e) {
        if ($(this).hasClass("gallery-popup-opener")) {
            $globalParent = $(this).parents(".property-gallery").next(".global-pop-up");
            $globalParent.find(".gallery-slider").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                fade: true,
                draggable: false,
                asNavFor: $globalParent.find('.slider-nav'),
                prevArrow:
                    "<button class='slick-arrow slick-prev'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M6.24625 0L0.24625 6L6.24625 12L7.75 10.5L3.24625 6L7.75 1.5L6.24625 0Z' fill='white'/></svg></button>",
                nextArrow:
                    "<button class='slick-arrow slick-next'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M1.75375 0L7.75375 6L1.75375 12L0.25 10.5L4.75375 6L0.25 1.5L1.75375 0Z' fill='white'/></svg></button>",
            });
            $globalParent.find(".slider-nav").slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                asNavFor: $globalParent.find(".gallery-slider"),
                dots: false,
                arrows: false,
                focusOnSelect: true,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 7,
                        },
                    },
                ],
            });
        } else if ($(this).hasClass("video-play-button")) {
            $globalParent = $(".video-holder").parents(".global-pop-up");

            $iframeScr = $(this).attr("data-src");

            if ($(this).attr("data-src") == undefined) {
                $iframeScr = $(this).parent().find(".video-play-button").attr("data-src");
            }

            let iframe = `
        <div class="iframe-wrapper">
        <button class="close-pop-up">
            <span></span>
            <span></span>
        </button>
        <iframe  class="video-iframe" width="100%" height="770" title="Video player" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen crossorigin src="">
        </iframe>
        </div>`;

            $globalParent.find(".video-holder").append(iframe);

            let $iframe = $globalParent.find("iframe");

            if ($iframeScr.match(/youtube/g)) {
                $src = `${$iframeScr}?rel=0&modestbranding=1&autoplay=1&mute=0&showinfo=0autohide=1`;
            }
            if ($iframeScr.match(/matterport/g)) {
                $src = `${$iframeScr}&play=1`;
            } else if (
                !$iframeScr.match(/youtube/g) &&
                !$iframeScr.match(/matterport/g)
            ) {
                $src = $iframeScr;
            }

            $iframe.attr("src", $src);
        } else {
            $globalParent = $(".person-bio").parents(".global-pop-up");
        }

        if (!$globalParent.hasClass("opened")) {
            $globalParent.addClass("opened");
            $body.addClass("overflow-y-hidden");
        }
    });

    $(window).on('resize', function () {
        galleryPopupResize();
    });

    function galleryPopupResize() {
        if ($(".gallery-slider").length && $(".gallery-slider").hasClass("slick-initialized")) {
            const numberOfSlides = $(".gallery-slider").find('.slick-slide').length;
            let slidesShown = $(".slider-nav").slick('slickGetOption', 'slidesToShow');
            if (numberOfSlides < slidesShown) {
                setTimeout(() => {
                    $(".slider-nav").find('.slick-track').css('transform', 'translate3d(0px, 0px, 0px)');
                }, 100);
            }
        }
    }

    $body.on("click", ".close-pop-up", function () {
        closePopup();
    });
    $(document).keydown(function (e) {
        if (e.keyCode == 27) {
            closePopup();
        }
    });
    $(".global-pop-up").on("click", function (e) {
        if (!e.target.closest(".pop-up-info")) {
            closePopup();
        }

    });

    function closePopup() {
        let $globalParent = $(".global-pop-up.opened");
        $body.removeClass("overflow-y-hidden");
        $globalParent.removeClass("opened");
        if ($globalParent.find(".gallery-slider").length) {
            $(".gallery-slider.slick-initialized").slick("unslick");
            $(".slider-nav.slick-initialized").slick("unslick");
        }
        if ($globalParent.find(".iframe-wrapper").length) {
            $globalParent.find(".iframe-wrapper").remove();
        }
        if ($globalParent.find(".person-bio").length) {
            $globalParent.find(".person-bio").removeClass("bio-updated");
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/popUp.js